var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 60,
    viewBox: "0 0 130 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5341_2563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.828 0.222656C106.828 0.222656 108.605 0.956487 110.603 2.79106C111.862 3.96519 113.491 6.60698 114.157 7.4142L121.19 1.47017C124.225 6.24007 128.223 5.79977 128.223 5.79977L121.264 11.597C122.745 11.8172 126.298 11.0834 129.852 13.3582C129.852 13.3582 122.449 19.5958 122.449 19.5224C118.895 17.1008 114.675 17.7612 114.009 17.6878L108.086 22.6045C108.086 22.6045 104.089 24.2923 100.165 19.0821C100.165 19.0821 106.902 13.5784 106.828 13.5784C106.013 12.8445 104.089 8.73509 99.3506 6.5336L106.828 0.222656Z",
    fill: "#00ADB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5797 19.0821V34.7127H7.84738V19.0821H0V58.4888H7.84738V42.1244H22.5797V58.4888H30.3531V19.0821H22.5797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6004 59.2226C60.3361 59.2226 66.7769 54.0124 66.7769 45.5734V19.0821H58.9295V44.9863C58.9295 48.8022 56.8566 51.6642 51.5263 51.6642C46.196 51.6642 44.1231 48.8022 44.1231 44.9863V19.0821H36.4238V45.5734C36.4238 54.0858 42.8646 59.2226 51.6004 59.2226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0991 59.2227C94.5388 59.2227 100.535 54.7463 100.535 47.3346C100.535 39.2625 93.8725 37.2077 87.5057 35.2264C81.5091 33.3918 79.9545 32.1443 79.9545 29.7227C79.9545 27.4478 81.8793 25.76 85.2107 25.76C89.2085 25.76 91.4294 27.8147 92.836 30.8234L99.4249 27.0809C96.7597 21.5771 91.7996 18.2749 85.2107 18.2749C78.3998 18.2749 72.1811 22.5311 72.1811 29.9428C72.1811 37.4279 78.1037 39.9229 84.1743 41.6841C90.0968 43.3719 92.762 44.4727 92.762 47.408C92.762 49.6095 91.1333 51.5908 86.3953 51.5908C81.4351 51.5908 78.6959 49.2426 77.2893 45.5734L70.6265 49.4627C72.6994 55.4067 78.0297 59.2227 86.0991 59.2227Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5341_2563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 59,
    fill: "white",
    transform: "translate(0 0.222656)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHus);
export default __webpack_public_path__ + "static/media/hus.2747289e1e9efedb2c2fe15cb4bbc312.svg";
export { ForwardRef as ReactComponent };